/** TUT-517 — as faixas de dia da central, como no Inbox do Linear. */
export type GrupoDaData = "Hoje" | "Ontem" | "Esta semana" | "Anteriores";

/** Os dias de calendário entre o aviso e agora, no fuso de quem lê (não 24 h corridas). */
function diasAtras(iso: string, agora: Date): number {
  const dia = new Date(iso);
  const inicioDoAviso = new Date(dia.getFullYear(), dia.getMonth(), dia.getDate()).getTime();
  const inicioDeHoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate()).getTime();
  return Math.round((inicioDeHoje - inicioDoAviso) / 86_400_000);
}

export function grupoDaData(iso: string, agora: Date): GrupoDaData {
  const dias = diasAtras(iso, agora);
  if (dias <= 0) return "Hoje";
  if (dias === 1) return "Ontem";
  if (dias < 7) return "Esta semana";
  return "Anteriores";
}
